import { createContext, useContext, useState } from 'react';
import axiosInstance from '../apiInstances/axiosInstance';

const PropertyDataContext = createContext();

export const PropertyDataProvider = ({ children }) => {
  const [propertyCache, setPropertyCache] = useState({});
  const [lastFetchTime, setLastFetchTime] = useState(0);
  const [blogCache, setBlogCache] = useState([]);
  const CACHE_EXPIRY_MS = 5 * 60 * 1000;

  const getCachedData = (key) => {
    if (propertyCache[key] && Date.now() - lastFetchTime < CACHE_EXPIRY_MS) {
      return propertyCache[key];
    }
    return null;
  };

  const cachePropertyData = (key, data) => {
    setPropertyCache(prev => ({
      ...prev,
      [key]: data
    }));
    setLastFetchTime(Date.now());
  };

  const fetchBlogs = async (options = {}) => {
    const { force = false } = options;
    if (!force && blogCache.length > 0 && Date.now() - lastFetchTime < CACHE_EXPIRY_MS) {
      return { ok: true };
    }

    try {
      const res = await axiosInstance.get(`/blog`);
      const raw = res?.data?.data;
      const data = Array.isArray(raw) ? raw : [];
      setBlogCache(data);
      setLastFetchTime(Date.now());
      return { ok: true };
    } catch (error) {
      console.error("Error fetching blogs:", error);
      return { ok: false };
    }
  };
  return (
    <PropertyDataContext.Provider value={{ getCachedData, cachePropertyData, fetchBlogs, blogCache }}>
      {children}
    </PropertyDataContext.Provider>
  );
};

export const usePropertyData = () => useContext(PropertyDataContext);
